/* eslint-disable react/forbid-prop-types */
import React, { useEffect, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import AppDatePicker from '../../../shared/components/app-date-picker/AppDatePicker';
import { getNewDate, isEmpty } from '../../../shared/helper-utils/appUtils';
import { TODAY_DATE } from '../../../shared/constants/Constants';
import AppNumberInput from '../../../shared/components/app-number-input/AppNumberInput';
import AppTextInput from '../../../shared/components/app-text-input/AppTextInput';
import AppButton from '../../../shared/components/app-button/AppButton';
import AppSelect from '../../../shared/components/app-select/AppSelect';
import AppAlert from '../../../shared/components/app-alert/AppAlert';

function EditCurrentAvailability({ coupon, onUpdateCurrentAvail }) {
  const TRUE_FALSE = [
    { label: 'True', value: 'true' },
    { label: 'False', value: 'false' },
  ];
  const [alert, setAlert] = useState(undefined);
  const [couponDetails, setCouponDetails] = useState({
    recordid: '',
    availdate: '',
    current_avail: '',
    total_avail: '',
    handlingcharges: '',
    flightnumber: '',
    departure_time: '',
    arrival_time: '',
    gds_pnr: '',
    autoissuance: false,
  });

  const getHoursMinutesFormat = (time) => {
    const numericValue = String(time).replace(/[^0-9]/g, '');
    const paddedValue = numericValue.padStart(4, '0');
    const hours = paddedValue.slice(0, -2);
    const minutes = paddedValue.slice(-2);
    const validHours =
      Number.isNaN(hours) || hours > 23 ? '00' : hours.padStart(2, '0');
    const validMinutes =
      Number.isNaN(minutes) || minutes > 59 ? '00' : minutes.padStart(2, '0');
    return `${validHours}:${validMinutes}`;
  };
  useEffect(() => {
    if (coupon) {
      setCouponDetails((prev) => ({
        ...prev,
        recordid: coupon.Recordid,
        availdate: coupon.AvailaDate,
        current_avail: coupon.CurrentAvail,
        total_avail: coupon.TotalAvail,
        handlingcharges: coupon.HandlingCharges,
        flightnumber: coupon.FlightNumber,
        departure_time: getHoursMinutesFormat(coupon.DepartureTime),
        arrival_time: getHoursMinutesFormat(coupon.ArrivalTime),
        gds_pnr: coupon.GDSPnr,
        autoissuance: coupon.AutoIssuance,
      }));
    }
  }, []);

  const handleUpdateCoupon = (name, value) => {
    if (name === 'gds_pnr') {
      const sanitizedValue = value.replace(/[^a-zA-Z0-9]/g, '');
      setCouponDetails((prev) => ({
        ...prev,
        [name]: sanitizedValue,
      }));
      return;
    }
    // if (name === 'autoissuance') {
    //   if (
    //     isEmpty(couponDetails.gds_pnr) ||
    //     couponDetails.gds_pnr.length !== 6 ||
    //     /[a-zA-Z0-9]/.test(couponDetails.gds_pnr) === false
    //   ) {
    //     setAlert({
    //       variant: 'error',
    //       title: 'Auto issuance',
    //       description: 'Enter valid pnr',
    //     });
    //     return;
    //   }
    // }
    setCouponDetails((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const getFormattedTime = (time) => {
    const timeWithoutSymbol = time.replace(':', '');
    return timeWithoutSymbol;
  };
  const handleUpdateDaywiseAvail = async () => {
    if (
      couponDetails.autoissuance === 'true' &&
      (isEmpty(couponDetails.gds_pnr) ||
        couponDetails.gds_pnr.length !== 6 ||
        /[a-zA-Z0-9]/.test(couponDetails.gds_pnr) === false)
    ) {
      setAlert({
        variant: 'error',
        title: 'Edit',
        description: 'Enter valid pnr',
      });
      return;
    }
    couponDetails.departure_time = getFormattedTime(
      couponDetails.departure_time,
    );
    couponDetails.arrival_time = getFormattedTime(couponDetails.arrival_time);
    onUpdateCurrentAvail(couponDetails);
  };

  const getTotalValue = () => {
    if (!Number.isNaN(couponDetails.handlingcharges)) {
      if (
        coupon.HandlingCharges !== parseInt(couponDetails.handlingcharges, 10)
      ) {
        const total_amount =
          coupon.StartingFare +
          (parseInt(couponDetails.handlingcharges, 10) || 0);
        return total_amount;
      }
      return coupon.TotalAmount;
    }
    return coupon.TotalAmount;
  };
  return (
    <>
      {alert && (
        <AppAlert
          showIcon
          variant={alert.variant}
          title={alert.title}
          description={alert.description}
          onHide={() => {
            setAlert(undefined);
          }}
        />
      )}
      <div className="add-coupon p-3">
        {coupon ? (
          <div className="add-coupon_details">
            <div className="add-coupon_details_content">
              <Row className="spacing-8-special mb-2">
                <Col lg={3} md={3} sm={6} xs={6}>
                  <AppTextInput
                    placeholderText=""
                    name="recordid"
                    id="recordid"
                    disabled
                    label="Record Id"
                    value={couponDetails.recordid}
                  />
                </Col>
                <Col lg={3} md={3} sm={6} xs={6}>
                  <AppTextInput
                    placeholderText=""
                    name="couponid"
                    id="couponid"
                    disabled
                    label="Coupon Id"
                    value={coupon.CouponId}
                  />
                </Col>
                <Col lg={3} md={3} sm={6} xs={6}>
                  <AppTextInput
                    placeholderText=""
                    name="startingFare"
                    id="startingFare"
                    disabled
                    label="Starting Fare"
                    value={coupon.StartingFare}
                  />
                </Col>
                <Col lg={3} md={3} sm={6} xs={6}>
                  <AppTextInput
                    placeholderText=""
                    name="totalFare"
                    id="totalFare"
                    disabled
                    label="Total Fare"
                    value={getTotalValue()}
                  />
                </Col>
                <Col lg={3} md={3} sm={6} xs={6}>
                  <AppDatePicker
                    name="jdate"
                    labelClassName="booking-date-label"
                    id="jdate"
                    label="Departure Date"
                    className="app-date-picker"
                    customClassName=" position-relative flight-booking-picker"
                    minDate={getNewDate(TODAY_DATE)}
                    selectedDate={
                      !isEmpty(coupon.AvailaDate) &&
                      getNewDate(coupon.AvailaDate)
                    }
                    disabled
                  />
                </Col>
                <Col lg={3} md={3} sm={6} xs={6}>
                  <AppDatePicker
                    name="jdate"
                    labelClassName="booking-date-label"
                    id="jdate"
                    label="Arrival Date"
                    className="app-date-picker"
                    customClassName=" position-relative flight-booking-picker"
                    minDate={getNewDate(TODAY_DATE)}
                    selectedDate={
                      !isEmpty(coupon.ArrivalDate) &&
                      getNewDate(coupon.ArrivalDate)
                    }
                    disabled
                  />
                </Col>
                <Col lg={3} md={3} sm={6} xs={6}>
                  <AppNumberInput
                    placeholderText=""
                    value={couponDetails.total_avail}
                    name="total_avail"
                    id="total_avail"
                    disabled
                    label="Total Seats"
                    onChange={(d) => handleUpdateCoupon('total_avail', d)}
                  />
                </Col>
                <Col lg={3} md={3} sm={6} xs={6}>
                  <AppTextInput
                    placeholderText=""
                    name="flightnumber"
                    id="flightnumber"
                    label="Flight Number"
                    value={couponDetails.flightnumber}
                    onChange={(e) =>
                      handleUpdateCoupon('flightnumber', e.target.value)
                    }
                  />
                </Col>
                <Col lg={3} md={3} sm={6} xs={6}>
                  <AppNumberInput
                    placeholderText=""
                    value={couponDetails.current_avail}
                    name="current_avail"
                    id="current_avail"
                    label="Available Seats"
                    onChange={(d) => handleUpdateCoupon('current_avail', d)}
                  />
                </Col>
                <Col lg={3} md={3} sm={6} xs={6}>
                  <AppTextInput
                    placeholderText=""
                    name="handlingcharges"
                    id="handlingcharges"
                    label="Additional Charge"
                    value={couponDetails.handlingcharges}
                    onChange={(e) =>
                      handleUpdateCoupon('handlingcharges', e.target.value)
                    }
                  />
                </Col>
                <Col lg={3} md={3} sm={6} xs={6}>
                  <AppTextInput
                    name="departure_time"
                    id="departure_time"
                    type="time"
                    required
                    label="Departure Time"
                    value={couponDetails.departure_time}
                    onChange={(e) =>
                      handleUpdateCoupon('departure_time', e.target.value)
                    }
                  />
                </Col>
                <Col lg={3} md={3} sm={6} xs={6}>
                  <AppTextInput
                    name="arrival_time"
                    id="arrival_time"
                    type="time"
                    required
                    label="Arrival Time"
                    value={couponDetails.arrival_time}
                    onChange={(e) =>
                      handleUpdateCoupon('arrival_time', e.target.value)
                    }
                  />
                </Col>
                <Col lg={3} md={3} sm={6} xs={6}>
                  <AppTextInput
                    placeholderText=""
                    name="gds_pnr"
                    id="gds_pnr"
                    label="PNR"
                    value={couponDetails.gds_pnr}
                    onChange={(e) =>
                      handleUpdateCoupon('gds_pnr', e.target.value)
                    }
                  />
                </Col>
                <Col lg={3} md={3} sm={6} xs={6}>
                  <AppSelect
                    placeholder=""
                    name="autoissuance"
                    id="autoissuance"
                    label="Auto Issuance/ Live PNR"
                    selectedValue={couponDetails.autoissuance}
                    options={TRUE_FALSE}
                    isClearable={false}
                    onSelect={(d) =>
                      handleUpdateCoupon('autoissuance', d.value)
                    }
                  />
                </Col>
              </Row>
            </div>
            <div className="d-flex justify-content-center align-items-center">
              <AppButton btnText="Update" onClick={handleUpdateDaywiseAvail} />
            </div>
          </div>
        ) : (
          <div>Details Not Found</div>
        )}
      </div>
    </>
  );
}

EditCurrentAvailability.propTypes = {
  coupon: PropTypes.any.isRequired,
  onUpdateCurrentAvail: PropTypes.any.isRequired,
};

export default EditCurrentAvailability;
